/**
 * 如果输入值有小数，则返回其长度和原始值的和。
 * @param s 输入值
 * @param origin 原始值
 */
var getN = function getN(s, origin) {
  if (s && s.toString().split('.') && s.toString().split('.')[1]) {
    return origin + s.toString().split('.')[1].length;
  }

  return origin;
};

export function add(arg1, arg2) {
  var r1 = getN(arg1, 0);
  var r2 = getN(arg2, 0);
  var m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}
export function sub(arg1, arg2) {
  return add(arg1, -arg2);
}
export function mul(arg1, arg2) {
  var s1 = arg1.toString();
  var s2 = arg2.toString();
  var m = 0;
  m = getN(arg1, m);
  m = getN(arg2, m);
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}
export function div(arg1, arg2) {
  var t1 = 0;
  var t2 = 0;
  t1 = getN(arg1, t1);
  t2 = getN(arg2, t2);
  var r1 = Number(arg1.toString().replace('.', ''));
  var r2 = Number(arg2.toString().replace('.', ''));
  return r1 / r2 * Math.pow(10, t2 - t1);
}